<div class="cliente-analise-mercado-projecao-progress">
    <div class="cliente-analise-mercado-projecao-progress-item cliente-analise-mercado-projecao-progress-item-totais">
        <!-- Projetado -->
        <div class="cliente-analise-mercado-projecao-progress-item-totais-block cliente-analise-mercado-projecao-progress-item-totais-block-values">
            <ul class="list-group">
                <li class="list-group-item list-group-item-tipo-carteira" [title]="tipoCarteiraProjetada.nome">
                    {{tipoCarteiraProjetada.abreviacao}}
                </li>
                <li class="list-group-item" *ngIf="controleQuantidade" title="Quantidade">
                    Q {{quantidadeProjetada | decimalFormat: 1:0:0}}
                </li>
                <li class="list-group-item" *ngIf="controlePeso" title="Peso">
                    P {{pesoProjetado | decimalFormat: 1:0:0}}
                </li>
                <li class="list-group-item" *ngIf="controleValor" title="Valor">
                    {{valorProjetado | currencyFormat: 1:0:0}}
                </li>
            </ul>
        </div>

        <!-- Title -->
        <div class="cliente-analise-mercado-projecao-progress-item-totais-block cliente-analise-mercado-projecao-progress-item-totais-block-title" *ngIf="title">
            <p>{{title}}</p>
        </div>

        <!-- Realizado -->
        <div class="cliente-analise-mercado-projecao-progress-item-totais-block cliente-analise-mercado-projecao-progress-item-totais-block-values">
            <ul class="list-group">
                <li class="list-group-item list-group-item-tipo-carteira" [title]="tipoCarteiraRealizada.nome">
                    {{tipoCarteiraRealizada.abreviacao}}
                </li>
                <li class="list-group-item" *ngIf="controleQuantidade" title="Quantidade">
                    Q {{quantidadeRealizada | decimalFormat: 1:0:0}}
                </li>
                <li class="list-group-item" *ngIf="controlePeso" title="Peso">
                    P {{pesoRealizado | decimalFormat: 1:0:0}}
                </li>
                <li class="list-group-item" *ngIf="controleValor" title="Valor">
                    {{valorRealizado | currencyFormat: 1:0:0}}
                </li>
            </ul>
        </div>        
    </div>
    <div class="cliente-analise-mercado-projecao-progress-item cliente-analise-mercado-projecao-progress-item-progressbar">
        <sgt-cliente-carteira-tipo-realizada-perc-progress
            [perc]="valorRealizadoPerc">
        </sgt-cliente-carteira-tipo-realizada-perc-progress>
    </div>    
</div>